<template>
  <vx-card>
    <vs-tabs alignment="fixed">
      <vs-tab label="Agravos">
        <AgravosPropostaList :subjectPermission="subjectPermission" />
      </vs-tab>
      <vs-tab label="Agravos-CEP">
        <AgravosCepList :subjectPermission="subjectPermission" />
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import AgravosCepList from './agravosCep/agravosCepList.vue';
import AgravosPropostaList from './agravosProposta/agravosPropostaList.vue';

export default {
  name: 'agravos-view',
  components: { AgravosPropostaList, AgravosCepList },
  data() {
    return {
      subjectPermission: 'Agravos',
    };
  },
};
</script>
<style></style>
